import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionDoingItemComponent } from './selection-doing-item/selection-doing-item.component';
import { SelectionCooperationItemComponent } from './selection-cooperation-item/selection-cooperation-item.component';
import { SelectionThreadItemComponent } from './selection-thread-item/selection-thread-item.component';



@NgModule({
  declarations: [
  
    SelectionDoingItemComponent,
       SelectionCooperationItemComponent,
       SelectionThreadItemComponent
  ],
  imports: [
    CommonModule
  ]
})
export class SelectionItemsModule { }
